export const SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js';
export const SCRIPT_ID = 'cf-turnstile-script';
export const SITE_KEY: string = window.__HB_ENV__.CLOUDFLARE_TURNSTILE_SITE_KEY;
export const DEFAULT_INPUT_NAME = 'captcha_response';
